import * as React from "react";
import { makeStyles } from "@material-ui/core";

// components
// import { LogoClock } from "@clockwise/web-commons/src/components/logo";

// styles
import { greys } from "@styles/color.styles";
import { AccessTime } from "@material-ui/icons";
import { fontFamilySans } from "@styles/type.styles";

// util
import { classNames } from "@util/html.util";
import { formatDuration } from "@util/duration.util";

export interface MeetingDurationProps {
  minutes: number;
  additionalText?: string;
  className?: string;
}

const useStyles = makeStyles({
  container: {
    display: "inline-block",
    color: greys.slate,
  },
  clockIcon: { marginRight: 5, verticalAlign: "middle" },
  text: {
    fontSize: `${14 / 16}rem`,
    verticalAlign: "middle",
    fontFamily: fontFamilySans,
  },
});

export const MeetingDuration = ({
  minutes,
  additionalText = "",
  className,
}: MeetingDurationProps) => {
  const classes = useStyles();

  const formattedDuration = formatDuration(minutes);
  return (
    <div className={classNames([classes.container, className])}>
      <AccessTime className={classes.clockIcon} fontSize="small" htmlColor={greys.darkestGrey} />
      <span
        className={classes.text}
        cw-id="meeting-duration"
        aria-label="meeting duration"
      >{`${formattedDuration}${additionalText}`}</span>
    </div>
  );
};
